// frontend/src/components/common/UsageBanner.tsx
import { Link } from 'react-router-dom';
import { usePlanUsage } from '../../hooks/usePlanUsage';

interface UsageBannerProps {
  type: 'lesson' | 'ai_message' | 'project';
}

const TYPE_LABELS = {
  lesson: 'ders tamamlama',
  ai_message: 'AI Mentor mesajı',
  project: 'proje oluşturma',
};

export function UsageBanner({ type }: UsageBannerProps) {
  const { usage, isAtLimit, isNearLimit, isLoading } = usePlanUsage();

  if (isLoading || !usage) return null;

  const atLimit = isAtLimit(type);
  const nearLimit = isNearLimit(type);

  if (!atLimit && !nearLimit) return null;

  let limitVal = 0;
  let usedVal = 0;
  if (type === 'lesson') {
    limitVal = usage.lessonsLimit || 0;
    usedVal = usage.lessonsUsed;
  } else if (type === 'ai_message') {
    limitVal = usage.aiMessagesLimit || 0;
    usedVal = usage.aiMessagesUsed;
  } else if (type === 'project') {
    limitVal = usage.projectsLimit || 0;
    usedVal = usage.projectsUsed;
  }

  if (atLimit) {
    return (
      <div 
        className="usage-banner error-banner" 
        style={{
          background: 'rgba(239, 68, 68, 0.08)',
          border: '1px solid rgba(239, 68, 68, 0.25)',
          color: '#fca5a5',
          padding: '12px 16px',
          borderRadius: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '20px',
          fontSize: '13px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '16px' }}>🚨</span>
          <span>
            Bugün için <strong>{TYPE_LABELS[type]}</strong> limitinizi (<strong>{usedVal}/{limitVal}</strong>) doldurdunuz! Hizmetleriniz geçici olarak sınırlandırılmıştır.
          </span>
        </div>
        <Link 
          to="/pricing" 
          className="plan-btn-primary" 
          style={{
            padding: '6px 12px',
            fontSize: '11px',
            textDecoration: 'none',
            background: 'var(--primary)',
            color: '#white',
            borderRadius: '6px',
            fontWeight: 600,
            whiteSpace: 'nowrap',
          }}
        >
          💎 Paketi Yükselt
        </Link>
      </div>
    );
  }

  if (nearLimit) {
    return (
      <div 
        className="usage-banner warning-banner" 
        style={{
          background: 'rgba(245, 158, 11, 0.08)',
          border: '1px solid rgba(245, 158, 11, 0.25)',
          color: '#fde047',
          padding: '12px 16px',
          borderRadius: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '20px',
          fontSize: '13px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '16px' }}>⚠️</span>
          <span>
            Bugün için <strong>{TYPE_LABELS[type]}</strong> limitinize yaklaştınız! (<strong>{usedVal}/{limitVal}</strong>)
          </span>
        </div>
        <Link 
          to="/pricing" 
          style={{
            color: '#fef08a',
            fontWeight: 600,
            fontSize: '12px',
            textDecoration: 'underline',
            whiteSpace: 'nowrap',
          }}
        >
          Sınırsız Paket Al →
        </Link>
      </div>
    );
  }

  return null;
}
